// Importa o mitt para criar um event bus
import mitt from 'mitt'

// Cria e exporta o event bus
export const emitter = mitt()

// Métodos de conveniência
export const emitEvent = (evento, dados) => {
  eventBus.emit(evento, dados)
}

export const onEvent = (evento, callback) => {
  eventBus.on(evento, callback)
}

export const offEvent = (evento, callback) => {
  eventBus.off(evento, callback)
}